import { Container, Row } from "reactstrap";
import JobDetailsRightCards from "./JobDetailsRightCards";
import { Breadcrumbs } from "../../../../AbstractElements";
import { JobDetails, JobSearch } from "../../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";
import LeftSidebar from "../Common/LeftSidebar/LeftSidebar";

const JobDetailsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={JobDetails} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <JobDetailsRightCards />
        </Row>
      </Container>
    </Fragment>
  );
};
export default JobDetailsContainer;
